import * as React from "react";
import { Button } from "@radix-ui/themes";
import SyntaxHighlighter from "react-syntax-highlighter";
import { solarizedDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { useMutation } from "convex/react";
import { toast } from "sonner";
import { formatDistance } from "date-fns";
import { Section } from "../common/section/Section.tsx";

interface Props {
  itemId: Id<"items">;
}

export const ItemContentSection: React.FC<Props> = ({ itemId }) => {
  const content = useQuery(api.itemContent.user.queries.findMineForItem, { itemId });
  const requestScrape = useMutation(api.itemContent.user.mutations.requestContentScrape);

  return (
    <Section
      title={"Saved copy"}
      description={"The article as it was fetched, which the reader, search and chat use."}
    >
      <SyntaxHighlighter
        language="markdown"
        style={solarizedDark}
        showLineNumbers={true}
        customStyle={{ height: "300px", margin: 0, borderRadius: 10, fontSize: 12.5 }}
      >
        {content?.content ?? ""}
      </SyntaxHighlighter>

      <Button
        disabled={content?.status.kind == "scraping_requested"}
        variant={"soft"}
        onClick={() => {
          requestScrape({ itemId }).catch(toast.error);
          toast("Fetching it again");
        }}
      >
        {content?.status.kind == "scraping_requested"
          ? `Will scrape in ${formatDistance(content.status.scheduledApiCallTime, new Date())}`
          : `Fetch it again`}
      </Button>
    </Section>
  );
};
